<template>
    <div v-if="!$apollo.queries.carDetails.loading && result !== ''" class="as-app-car-details" v-bind:class="{ 'share-api-available' : shareApiAvailable}">
        <!--    {{ $route.params.guid }}-->
        <div class="as-app-col as-app-col-12 hide-on-print"><a class="back-link" href="javascript:history.back()">&laquo;&nbsp;zurück</a></div>
        <div class="as-app-row as-app-wide details-header">
            <div class="as-app-col as-app-col-12 as-app-col-sm-6">
                <div class="relative-height ar-420-315">
                    <div class="relative-height-inner">
                        <ImageSlider :images="result.media.images"
                                     :guid="guid"></ImageSlider>
                    </div>
                    <div @click="sharePage" class="share-btn">
                        <font-awesome-icon :icon="['fas', 'share-alt']" />
                        Teilen
                    </div>
                </div>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6">
                <div>
                <span class="h1 headline">{{$R.pathOr('',['adProduct','title'], result)}}</span>
                <div class="as-app-upper-details-table">
                        <span class="as-app-price">
                              {{$R.pathOr('',['prices','public','amountInEUR','formatted'], result)}}
                        </span>
                        <div id="share-list-wrapper">
                            <div @click="toggleShareList" id="share-list-opener">
                                <font-awesome-icon :icon="['fas', 'share-alt']" />
                                Teilen
                            </div>
                            <ul id="share-list">
                                <li @click="shareOnFacebook">
                                    <font-awesome-icon :icon="['fab', 'facebook-f']" />
                                </li>
                                <li @click="shareOnTwitter">
                                    <font-awesome-icon :icon="['fab', 'twitter']" />
                                </li>
                                <li @click="copyLink">
                                    <font-awesome-icon :icon="['fas', 'link']" /><input id="copy-link" readonly :value="currentUrl">
                                </li>
                            </ul>
                        </div>
                        <div class="as-app-price-rating au-widget-car-rating" data-enable-box-constraints data-layout="wide_without_price_with_explanation" data-theme="transparent" :data-car-url="$store.state.siteUrl+$store.state.detailsPath+encodeURIComponent('-b-' + $R.pathOr('',['vehicle','classification','make','raw'], result) + '-' + $R.pathOr('',['vehicle','classification','make','formatted'], result) + '-m-' + $R.pathOr('',['vehicle','classification','model','formatted'], result).replace(/[^A-Za-z0-9]/g,'') + '-guid-' + guid + '-offerid-' + $R.pathOr('',['identifier','offerReference'], result))"></div>
                </div>
                <div class="as-app-details-table">
                    <div>
                        <span>
                            {{$R.pathOr('-',['vehicle','fuels','primary','co2emissionInGramPerKm', 'formatted'], result)}},
                            <template v-for="label in $R.pathOr([],['vehicle','environment','environmentLabels'], result)">
                                <template v-if="label.norm === 'EU_Directive_70_220_EEC_LDV'">{{label.label}}</template>
                            </template>
                        </span>
                    </div>

                    <div><span>{{$R.pathOr('-',['vehicle','condition','numberOfPreviousOwnersExtended','formatted'], result)}}</span>
                    </div>
                    <div class="as-app-full-width">
                        <span>
                            {{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','combined','raw'], result), 1)}}l/100km (komb),
                            {{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','urban','raw'], result), 1)}}l/100km (innerorts),
                            {{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','extraUrban','raw'], result), 1)}}l/100km (außerorts)
                        </span>
                    </div>
                    <div><span>{{$R.pathOr('-',['vehicle','condition','mileageInKm','formatted'], result)}}</span></div>
                    <div>
                        <span>{{$R.pathOr('-',['vehicle','condition','firstRegistrationDate','formatted'], result)}}</span>
                    </div>
                    <div><span>{{$R.pathOr('-',['vehicle','engine','power','kw','formatted'], result)}} ({{$R.pathOr('-',['vehicle','engine','power','hp','formatted'], result)}})</span>
                    </div>
                    <div><span>{{$R.pathOr('-',['vehicle','fuels','primary','source'], result)}}</span></div>
                </div>
                <div class="cta-box">
                    <div class="btn-ah-wrapper">
                        <a :href="'tel:' + $store.state.phoneAutoCRMLead" class="btn-ah has-fa">Jetzt anrufen <font-awesome-icon :icon="['fas', 'phone']" /></a>
                    </div>
                    <div class="btn-ah-wrapper">
                        <a :href="currentUrl+'#contact-form'" class="btn-ah btn-ah-clean-border has-fa">E-Mailanfrage <font-awesome-icon :icon="['far', 'envelope']" /></a>
                    </div>
                    <div class="btn-ah-wrapper">
                        <div @click="openTradeInModal" class="btn-ah btn-ah-clean-border has-fa">Inzahlungnahme <font-awesome-icon :icon="['fas', 'sync']" /></div>
                    </div>
                    <div class="btn-ah-wrapper">
                        <div @click="printPage" class="btn-ah btn-ah-clean-border has-fa">Drucken <font-awesome-icon :icon="['fas', 'print']" /></div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div class="as-app-row as-app-tight">
            <div class="as-app-col as-app-col-12">
                <span class="h2 headline">Fahrzeugdetails</span>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 as-app-col-horizontal-padding">
                <span class="h3 headline">Zustand</span>
                <div class="as-app-details-table spreaded">
                    <div>
                        <span class="row-title">Zustand</span>
                        <span>{{$R.pathOr('-',['vehicle','legalCategories','0','formatted'], result)}}</span></div>
                    <div>
                        <span class="row-title">Fahrzeughalter</span>
                        <span>{{$R.pathOr('-',['vehicle','condition','numberOfPreviousOwnersExtended','raw'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">HU/AU neu</span>
                        <span>{{$R.pathOr('-',['vehicle','condition','newInspection'], result) ? 'ja' : 'nein'}}</span>
                    </div>
                    <div>
                        <span class="row-title">Garantie</span>
                        <span>{{$R.pathOr('-',['warranty','warrantyExists'], result) ? 'ja' : 'nein'}}</span>
                    </div>
                    <div>
                        <span class="row-title">Scheckheftgepflegt</span>
                        <span>{{$R.pathOr('-',['vehicle','maintenance','hasFullServiceHistory','raw'], result) ? 'ja' : 'nein'}}</span>
                    </div>
                </div>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 as-app-col-horizontal-padding">
                <span class="h3 headline">Merkmale</span>
                <div class="as-app-details-table spreaded">
                    <div>
                        <span class="row-title">Marke</span>
                        <span>{{$R.pathOr('-',['vehicle','classification','make','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Modell</span>
                        <span>{{$R.pathOr('-',['vehicle','classification','model','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Angebotsnummer</span>
                        <span>{{$R.pathOr('-',['identifier','offerReference'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Erstzulassung</span>
                        <span>{{$R.pathOr('-',['vehicle','condition','firstRegistrationDate','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Außenfarbe</span>
                        <span>{{$R.pathOr('-',['vehicle','bodyColor','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Farbe laut Herstellung</span>
                        <span>{{$R.pathOr('-',['vehicle','bodyColorOriginal'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Innenausstattung</span>
                        <span>{{$R.pathOr('-',['vehicle','interior','upholstery','formatted'], result)+', '+$R.pathOr('-',['vehicle','interior','upholsteryColor','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Anzahl Türen</span>
                        <span>{{$R.pathOr('-',['vehicle','numberOfDoors'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Anzahl Sitzplätze</span>
                        <span>{{$R.pathOr('-',['vehicle','interior','numberOfSeats'], result)}}</span>
                    </div>
                </div>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-4 as-app-col-horizontal-padding">
                <span class="h3 headline">Antrieb</span>
                <div class="as-app-details-table spreaded">
                    <div>
                        <span class="row-title">Getriebeart</span>
                        <span>{{$R.pathOr('-',['vehicle','engine','transmissionType','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Anzahl Gänge</span>
                        <span>{{$R.pathOr('-',['vehicle','engine','numberOfGears'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Hubraum</span>
                        <span>{{$R.pathOr('-',['vehicle','engine','engineDisplacementInCCM','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Zylinder</span>
                        <span>{{$R.pathOr('-',['vehicle','engine','numberOfCylinders'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Leergewicht</span>
                        <span>{{$R.pathOr('-',['vehicle','emptyWeight','formatted'], result)}}</span>
                    </div>
                    <div>
                        <span class="row-title">Antriebsart</span>
                        <span>{{$R.pathOr('-',['vehicle','engine','driveTrain','formatted'], result)}}</span>
                    </div>
                </div>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-5 as-app-col-horizontal-padding">
                <span class="h3 headline">Umwelt</span>
                    <div class="as-app-details-table spreaded">
                        <div>
                            <span class="row-title">Kraftstoff</span>
                            <span>{{$R.pathOr('-',['vehicle','fuels','primary','type','formatted'], result)}}</span>
                        </div>
                        <div>
                            <span class="row-title">Kraftstoffverbrauch</span>
                            <div class="subtable">
                                <span>{{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','combined','raw'], result), 1)}}l/100km (komb)</span>
                                <span>{{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','urban','raw'], result), 1)}}l/100km (innerorts)</span>
                                <span>{{_.round( $R.pathOr('-',['vehicle','fuels','primary','consumption','extraUrban','raw'], result), 1)}}l/100km (außerorts)</span>
                            </div>
                        </div>
                        <div>
                            <span class="row-title">CO2-Emissionen</span>
                            <span>{{$R.pathOr('-',['vehicle','fuels','primary','co2emissionInGramPerKm', 'formatted'], result)}}</span>
                        </div>
                        <template v-for="label in $R.pathOr([],['vehicle','environment','environmentLabels'], result)">
                            <div v-if="label.norm === 'EU_Directive_70_220_EEC_LDV'" :key="label.norm">
                                <span class="row-title">Abgasnorm</span>
                                <span>{{label.label}}</span></div>
                        </template>
                        <template v-for="label in $R.pathOr([],['vehicle','environment','environmentLabels'], result)">
                            <div v-if="label.norm === 'BImSchV_35'" :key="label.norm">
                                <span class="row-title">Feinstaubplakette</span>
                                <span>{{label.label}}</span></div>
                        </template>
                    </div>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-3 as-app-col-horizontal-padding">
                <span class="h3 headline">CO2-Effizienz</span>
                <p class="small">Auf der Grundlage der gemessenen CO2-Emissionen unter Berücksichtigung der Masse des Fahrzeugs ermittelt.</p>
                <template v-for="label in $R.pathOr([],['vehicle','environment','environmentLabels'], result)">
                    <div v-if="label.norm === 'PkwEnVKV'" class="envkv" :key="label.norm">
                        <ul class="envkv-list">
                            <li class="envkv-row envkv-a-plus" :class="label.label === 'ENVKV_A_PLUS' || label.label === 'ENVKV_APLUS' || label.label === 'ENVKV_A+'? 'active' : ''">
                                <div class="beam">A+</div><div class="marker">A+</div>
                            </li>
                            <li class="envkv-row envkv-a" :class="label.label === 'ENVKV_A' ? 'active' : ''">
                                <div class="beam">A</div><div class="marker">A</div>
                            </li>
                            <li class="envkv-row envkv-b" :class="label.label === 'ENVKV_B' ? 'active' : ''">
                                <div class="beam">B</div><div class="marker">B</div>
                            </li>
                            <li class="envkv-row envkv-c" :class="label.label === 'ENVKV_C' ? 'active' : ''">
                                <div class="beam">C</div><div class="marker">C</div>
                            </li>
                            <li class="envkv-row envkv-d" :class="label.label === 'ENVKV_D' ? 'active' : ''">
                                <div class="beam">D</div><div class="marker">D</div>
                            </li>
                            <li class="envkv-row envkv-e" :class="label.label === 'ENVKV_E' ? 'active' : ''">
                                <div class="beam">E</div><div class="marker">E</div>
                            </li>
                            <li class="envkv-row envkv-f" :class="label.label === 'ENVKV_F' ? 'active' : ''">
                                <div class="beam">F</div><div class="marker">F</div>
                            </li>
                            <li class="envkv-row envkv-g" :class="label.label === 'ENVKV_G' ? 'active' : ''">
                                <div class="beam">G</div><div class="marker">G</div>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>

        </div>
        <div class="as-app-row">
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 as-app-col-horizontal-padding">
                <span class="h3 headline">Komfort</span>
                <ul class="equipment-list">
                    <li v-for="(item, index) in comfort" :key="'comfort-item-'+index">
                        {{item.id.formatted}}
                    </li>
                </ul>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 as-app-col-horizontal-padding">
                <span class="h3 headline">Sicherheit</span>
                <ul class="equipment-list">
                    <li v-for="(item, index) in safety" :key="'safety-item-'+index">
                        {{item.id.formatted}}
                    </li>
                </ul>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6 as-app-col-horizontal-padding">
                <span class="h3 headline">Entertainment</span>
                <ul class="equipment-list">
                    <li v-for="(item, index) in enternainment" :key="'entertainment-item-'+index">
                        {{item.id.formatted}}
                    </li>
                </ul>
            </div>
            <div class="as-app-col as-app-col-12 as-app-col-sm-6">
                <span class="h3 headline">Extras</span>
                <ul class="equipment-list">
                    <li v-for="(item, index) in extras" :key="'extras-item-'+index">
                        {{item.id.formatted}}
                    </li>
                </ul>
            </div>
        </div>
        <div class="as-app-row">
            <div class="as-app-col as-app-col-12">
                <span class="h2 headline">Beschreibung</span>
                <div v-html="$R.pathOr('-',['description'], result)" class="description"></div>
            </div>
        </div>
        <div class="as-app-row only-print">
            <div class="as-app-col as-app-col-12">
                <ImageSlider :images="result.media.images"
                             :guid="guid"></ImageSlider>
            </div>
        </div>
    </div>
    <div v-else class="as-app-spinner load-more">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</template>

<script>
    /*global auWidgetEmbed, auWidgetConfig, window */
    // @ is an alias to /src
    import Vue from 'vue'
    import ImageSlider from '@/components/ImageSlider.vue'


    export default {
        name: 'cardetails',
        components: {
            ImageSlider
        },
        data() {
            return {
                result: '',
                currentUrl: window.location.href,
                guid: this.$route.params.guid,
                offerid: this.$route.params.offerid,
                shareApiAvailable : false
            }
        },
        methods: {
            getNumberByBrand (brandId){
                brandId = parseInt(brandId)
                let phonenumber = '0'
                if(brandId === 64 || brandId === 51802){
                   // SEAT, CUPRA
                    phonenumber = this.$store.state.phoneLocationSEAT
                } else if(brandId === 6 || brandId === 28 || brandId === 16396 || brandId === 38){
                   // FCA
                    phonenumber = this.$store.state.phoneLocationFCA
                } else {
                    phonenumber = this.$store.state.phoneLocationVW
                }
                return phonenumber
            },
            printPage (){
                window.print()
            },
            sharePage(){
                if (navigator.share) {
                    const title = document.title;
                    const url = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href;

                    navigator.share({
                        title: title,
                        url: url
                    }).then(() => {
                        if(typeof window.fbq === 'function') {
                            window.fbq('trackCustom', 'carShared')
                        }
                        if(typeof window.gtag === 'function') {
                            window.gtag('event', 'carShared', {
                                'event_category' : 'sharingInteraction'
                            });
                        }
                    })
                        .catch(console.error);
                } else {
                    // fallback
                }
            },
            toggleShareList(){
                if(document.getElementById('share-list-wrapper').className.indexOf('open') >= 0){
                    document.getElementById('share-list-wrapper').className = '';
                } else {
                    document.getElementById('share-list-wrapper').className = 'open';
                }
            },
            shareOnFacebook(){
                const url = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href
                window.open(
                    'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url),
                    'Share on Facebook',
                    'width=626,height=436')
                return false
            },
            shareOnTwitter(){
                const title = document.title;
                const url = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href
                window.open("https://twitter.com/intent/tweet?text="+title+"&url="+encodeURIComponent(url), "pop", "width=600, height=400, scrollbars=no")
                return false
            },
            copyLink(){
                var copyText = document.getElementById('copy-link')
                copyText.select();
                document.execCommand("copy");
            },
            openTradeInModal (){
                window.AuEmbed.TradeInCalculatorWidgetEmbedder.openTradeInModal()
            }
        },
        mounted: function () {
            let showAuPopup = typeof showAuPopup !== 'undefined' ? showAuPopup : false;
            if(document.getElementById('au-cweb-script') == null){
                window.AuEmbed=window.AuEmbed || {pushedUrls:[],pushUrl:function(url){window.AuEmbed.pushedUrls.push(url)}};
                window.AuEmbed = {
                    config: {
                        id: "W3NnIHluQk",
                        stockId: this.offerid,
                    }
                };
                let d={depId:window.AuEmbed.config.departmentId,device:window.matchMedia(
                        "only screen and (max-width: 760px)").matches?"mobile":"desktop",
                        pageType:window.AuEmbed.config.pageType,
                        url:window.AuEmbed.config.previewUrl||document.location.href},
                    sc=document.createElement("script");sc.async=!0,
                    sc.src="https://www.autouncle.de/de/customers/"+encodeURIComponent(
                        window.AuEmbed.config.id)+"/website_script.js?d="+encodeURIComponent(
                        JSON.stringify(d)),sc.id="au-cweb-script",
                    h=document.getElementsByTagName("head")[0],h.insertBefore(sc,
                    h.lastChild);
            }



            // Widget bleibt so bestehen (24.01.2022)
            window.auWidgetConfig = {sourceName: 'Autohäuser Pohlheim'}
            let s=document.createElement('script')
            s.async=true
            s.src='//www.autouncle.de/widgets/embed.js?source_name='+encodeURIComponent(auWidgetConfig.sourceName)
            s.setAttribute('data-source-name',auWidgetConfig.sourceName)
            s.id='au-widget-script'
            let h=document.getElementsByTagName('head')[0]
            h.insertBefore(s,h.lastChild)

            if(navigator.share){
                this.shareApiAvailable = true
            }
        },
        computed: {
            comfort() {
                return this.result.vehicle.equipment.as24.filter(function(arrItem){
                    return arrItem.category.formatted === 'Komfort'
                })
            },
            safety() {
                return this.result.vehicle.equipment.as24.filter(function(arrItem){
                    return arrItem.category.formatted === 'Sicherheit'
                })
            },
            extras() {
                return this.result.vehicle.equipment.as24.filter(function(arrItem){
                    return arrItem.category.formatted === 'Extras'
                })
            },
            enternainment() {
                return this.result.vehicle.equipment.as24.filter(function(arrItem){
                    return arrItem.category.formatted === 'Unterhaltung/Media'
                })
            }
        },
        apollo: {
            /////////////////////////////////
            // Get Results based in Inputs //
            /////////////////////////////////

            carDetails: {
                query: require('../graphql/CarDetails.gql'),
                errorPolicy: 'all',
                fetchPolicy: 'no-cache', //Otherwise apollo merges some objectarrays wrong
                manual: true,
                // skip: true,
                variables() {
                    // Use vue reactive properties here
                    return {
                        guid: this.guid,
                    }
                },
                error(error) {
                    console.log('Car of the week might not be available anymore.')
                    // console.log({error})
                    if(parseInt(error.networkError.statusCode) === 429){
                        Vue.logApiLimitReached();
                    }
                },
                result(data) {
                    //console.log('RAW', data);
                    if (typeof data.error === 'undefined' && typeof data.data !== 'undefined' && !data.loading) {
                        // console.log(data.data);
                        this.result = data.data.search.listing.details
                        this.$nextTick(() => {
                            if(typeof auWidgetEmbed !== 'undefined' && typeof auWidgetEmbed.init !== 'undefined'){
                                auWidgetEmbed.init()
                            }
                        })

                        // Filter images
                        this.result.media.images = this.result.media.images.filter(Vue.filterImages)
                        // console.log(document.querySelector("meta[property='og:image']"));
                        if(document.querySelector("meta[property='og:image']") !== undefined){
                            document.querySelector("meta[property='og:image']").content = this.result.media.images[0].formats.jpg.size1280x960;
                            // console.log(this.result.media.images[0].formats.jpg.size1280x960);
                        }
                        //console.log('result: ', this.result);
                    }
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    @import "../styles/style";
    @import "../styles/partials/_car-details";
</style>
<style lang="scss">
    .description{
        padding: .75rem;
        ul{
            list-style: none;
            padding: 0;
            margin: 0 auto;
        }
        li{
            strong{
                margin: 0;
            }
        }
        br{
            + ul {
                /*margin-top: -1.5rem;*/
            }
        }
        strong{
            display: block;
        }
        br + br + hr{
            margin-top: -1rem;
        }
    }
</style>
